module.exports = __webpack_public_path__ + "static/media/1_Thuiskok-logo-tekst.932969f4.png";